export default "__VITE_ASSET__Bhk7ZP5J__"